const $stream = async <I, O>(generator: AsyncGenerator<I>, fn: (value: I) => O) => {
  for await (const yielded of generator) {
    await fn(yielded)
  }
}
export function streamMagic(el: Node) {
  return $stream
}
